import { Component, OnInit, EventEmitter, ViewChild, QueryList, ViewChildren, Inject, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { EstadoInventarioService } from 'src/app/services/estado-inventario.service';
import { InventarioFisicoService } from 'src/app/services/inventario-fisico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { TipoMovimientoService } from 'src/app/services/tipo-movimiento.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ExistInventarioFisicoModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { ExistInventarioFisicoModalConsultaComponent } from './modal-consulta/modal-consulta.component';
import { ExistInventarioFisicoModalRealizarAjusteComponent } from './modal-realizar-ajuste/modal-realizar-ajuste.component';
import { ExistInventarioFisicoModalTomaInventarioComponent } from './modal-toma-inventario/modal-toma-inventario.component';
import { ExistInventarioFisicoModalEditarAjusteComponent } from './modal-edit-ajuste/modal-editar-ajuste.component';
import { Subscription } from 'apollo-client/util/Observable';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';
@Component({
  selector: 'app-exist-inventario-fisico',
  templateUrl: './exist-inventario-fisico.component.html',
  styleUrls: ['./exist-inventario-fisico.component.scss'],
  providers: [SecurityService],
})
export class ExistInventarioFisicoComponent implements OnInit {
  @ViewChild(ExistInventarioFisicoModalAddEditComponent, { static: true }) modalAddEdit: ExistInventarioFisicoModalAddEditComponent;
  @ViewChild(ExistInventarioFisicoModalConsultaComponent, { static: true }) modalConsulta: ExistInventarioFisicoModalConsultaComponent;
  @ViewChild(ExistInventarioFisicoModalRealizarAjusteComponent, { static: true }) modalRealizarAjuste: ExistInventarioFisicoModalRealizarAjusteComponent;
  @ViewChild(ExistInventarioFisicoModalTomaInventarioComponent, { static: true }) modalTomaInventario: ExistInventarioFisicoModalTomaInventarioComponent;
  @ViewChild(ExistInventarioFisicoModalEditarAjusteComponent, { static: true }) modalEditarAjuste: ExistInventarioFisicoModalEditarAjusteComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Form
  formHeader: FormGroup;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  listaMovimientos: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();
  loading: boolean = false;
  loaded: boolean = false;
  currentPayload: any;

  optionsBodega: Array<any> = [];
  optionsEstado: Array<any> = [];

  //TODO: VARIABLES PARA SCROLL
  currentPayLoad: any;
  totalRegistrosPos: any;
  totalPagPos: any;
  PagPosActual: any;
  notEmptyPost = true;
  notscrolly = true;
  subscription: Subscription;
  private scrollHeight = 100;
  private PageNum = 1;
  showButton = false;
  showButtonDown: boolean;

  // Utils
  private log: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private spinner: NgxSpinnerService,
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private bodegaServ: BodegaService,
    private estadoInventarioService: EstadoInventarioService,
    private tipoMovimientoServ: TipoMovimientoService,
    private tipoDocumentoService: TipoDTEService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private datesService: DatesService,
    private inventarioFisicoService: InventarioFisicoService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('INVENTARIO');

    this.onScrollTop();
  }

  optionsRubro: Array<any> = [];
  optionsBodega2: Array<any> = [];
  optionsMotivo2: Array<any> = [];
  optionsTipDocumento: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsBodegaSalida: Array<any> = [];
  optionsBodegaIngreso: Array<any> = [];
  optionsFormato: Array<any> = [];

  @HostListener('window:scroll')
  onWindowsScroll(): void {
    const yOffSet = window.pageYOffset;
    const scrollTop = this.document.documentElement.scrollTop;

    //* MOSTRAR U OCULTAR BOTONES DE AYUDA SCROLL
    if (this.listaMovimientos != null) {
      this.showButton = (yOffSet || scrollTop) > this.scrollHeight;
      this.showButtonDown = (yOffSet || scrollTop) >= 0;
    }
  }

  //* LA BARRA DEL SCROLL QUEDA AL INICIO AL INGRESAR A LA VISTA - SCROLL CON BOTON SUBIR
  onScrollTop(): void {
    this.document.documentElement.scrollTop = 0;
  }

  //* SE PUEDE REALIZAR UN SCROLL A TRAVES DEL BOTON BAJAR
  onScrollAbajo(): void {
    this.document.documentElement.scrollBy(0, 1000);
  }

  //* AL REALIZAR EL SCROLL HACIA ABAJO SE AGREGAN LOS SIGUIENTES 100 DATOS DE LA PAGINA SGTE
  onScrollDown(e): void {
    console.log(e);
    const inputParams = _.cloneDeep(this.currentPayLoad);
    console.log(inputParams);
    if (inputParams != undefined || inputParams != null) {
      console.log('entro aqui');
      delete inputParams.paginaActual;
      this.PageNum += 1;
      inputParams.paginaActual = this.PageNum;

      this.spinner.show();
      if (this.notscrolly && this.notEmptyPost) {
        console.log('entra aqui', this.notscrolly, this.notEmptyPost);
        self.document.getElementById('spinnerX').style.display = 'block';

        this.inventarioFisicoService.getInventarioFisico(inputParams);

        this.inventarioFisicoService.queryCliente.subscribe((data: any[]) => {
          console.log(data[0].obtenerSegunFiltro.respuesta);
          this.PagPosActual = data[0].obtenerSegunFiltro.respuesta.paginaActual;
          this.totalPagPos = data[0].obtenerSegunFiltro.respuesta.totalPaginas;
          this.totalRegistrosPos = data[0].obtenerSegunFiltro.respuesta.totalRegistros;
          this.listaMovimientos.push(...data[0].obtenerSegunFiltro.respuesta.registros);

          this.listaMovimientos.map((mov) => {
            const estado = mov.estado_inventario_codigo;
            mov.additionalData = {
              allowTomaInvenario: !(estado === 2 || estado === 3 || estado === 4),
              allowEditar: !(estado === 2 || estado === 3 || estado === 4),
              allowEliminar: !(estado === 3 || estado === 4),
              allowRealizarAjuste: !(estado === 1 || estado === 3 || estado === 4),
            };
          });
          // console.log("Dame los siguientes datos del paginado",this.listOfCliente)
          this.spinner.hide();
          self.document.getElementById('spinnerX').style.display = 'block';
          if (data[0].obtenerSegunFiltro.respuesta.paginaActual === data[0].obtenerSegunFiltro.respuesta.totalPaginas) {
            this.notEmptyPost = false;
            self.document.getElementById('spinnerX').style.display = 'none';
          }
          if (data[0].obtenerSegunFiltro.respuesta.registros.length < data[0].obtenerSegunFiltro.respuesta.cantidadRegistrosPorPagina) {
            self.document.getElementById('spinnerX').style.display = 'none';
            this.PagPosActual = 1;
          }
          this.notscrolly = true;
        });
      }
    }
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.onScrollTop();

    this.paginationContext.RecordsByPage = 20;

    // Bodegas
    this.loadBodegas();

    // Estados
    this.loadEstados();

    // Form and changes in Tipo Movimiento
    this.createForm();
    this.formChangesSubscriptions();
    // this.onChanges();
  }

  loadBodegas() {
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }));
    });
  }

  loadEstados() {
    this.estadoInventarioService.obtenerTodos(({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsEstado = registros.map((estado) => ({ value: estado.codigo, label: estado.nombre, ...estado }));
    });
  }

  createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      fechaInicio: [initDate],
      fechaFin: [currentDate],
      bodega: [[]],
      estado: [[]],
      nroDoc: [''],
    });
  }

  formChangesSubscriptions() {}

  showModalConsulta() {
    this.modalConsulta.loadInventarFisicoByCodigo(this.formHeader.get('nroDoc').value);
  }

  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return
    this.paginationContext.CurrentPage = pageNumber;
    this.listaMovimientos = [];
    const self = this; // this is unused

    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde: this.formHeader.get('fechaInicio').value,
        fecha_hasta: this.formHeader.get('fechaFin').value,
        listaBodega: this.formHeader.get('bodega').value,
        listaEstado: this.formHeader.get('estado').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: 20,
    };
    this.currentPayLoad = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams));

    // this.loading = true
    // this.inventarioFisicoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }

    //   const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
    //   this.paginationContext.RecordsCount = totalRegistros
    //   this.paginationContext.CurrentPage = paginaActual
    //   this.paginationContext.PagesCount = totalPaginas
    //   this.listaMovimientos = registros
    //   this.listaMovimientos.map(mov => {
    //     const estado = mov.estado_inventario_codigo
    //     mov.additionalData = {
    //       allowTomaInvenario: !(estado === 2 || estado === 3 || estado === 4),
    //       allowEditar: !(estado === 2 || estado === 3 || estado === 4),
    //       allowEliminar: !(estado === 3 || estado === 4),
    //       allowRealizarAjuste: !(estado === 1 || estado === 3 || estado === 4),
    //     }
    //   })
    //   this.loading = false
    // })

    this.spinner.show();

    this.inventarioFisicoService.getInventarioFisico(inputParams);

    this.inventarioFisicoService.queryCliente.subscribe((data: any[]) => {
      this.PagPosActual = data[0].obtenerSegunFiltro.respuesta.paginaActual;
      this.totalPagPos = data[0].obtenerSegunFiltro.respuesta.totalPaginas;
      this.totalRegistrosPos = data[0].obtenerSegunFiltro.respuesta.totalRegistros;
      this.listaMovimientos = data[0].obtenerSegunFiltro.respuesta.registros.slice(0, 20);
      this.listaMovimientos.map((mov) => {
        const estado = mov.estado_inventario_codigo;
        mov.additionalData = {
          allowTomaInvenario: !(estado === 2 || estado === 3 || estado === 4),
          allowEditar: !(estado === 2 || estado === 3 || estado === 4),
          allowEliminar: !(estado === 3 || estado === 4),
          allowRealizarAjuste: !(estado === 1 || estado === 3 || estado === 4),
        };
      });
      this.spinner.hide();
      if (data[0].obtenerSegunFiltro.respuesta.paginaActual === data[0].obtenerSegunFiltro.respuesta.totalPaginas) {
        self.document.getElementById('spinnerX').style.display = 'none';
      }
    });
    this.notscrolly = true;
    this.notEmptyPost = true;
    this.PageNum = 1;
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage);
  }

  showModalAdd() {
    this.modalAddEdit.show();
  }

  loadModalEdit(mov) {
    this.modalAddEdit.load(mov);
  }

  loadModalConsulta(mov: any) {
    this.modalConsulta.loadInventarioFisico(mov);
  }

  loadModalRealizarAjuste(mov: any) {
    this.modalRealizarAjuste.load(mov);
  }

  loadModalTomaInventario(mov: any) {
    this.modalTomaInventario.load(mov);
  }

  loadModalEditarAjuste(mov: any) {
    this.modalEditarAjuste.load(mov);
  }

  eliminar(mov: any) {
    this.modalConfirm.show(() => {
      this.eliminarMovimiento(mov);
    });
  }

  eliminarMovimiento(mov) {
    const inputParams = {
      entidad: {
        rut_empresa: mov.rut_empresa,
        sucursal_codigo: mov.sucursal_codigo,
        codigo: mov.codigo,
        rut_usuario_responsable: mov.rut_usuario_responsable,
        bodega_codigo: mov.bodega_codigo,
        fecha_creacion: mov.fecha_creacion,
        detalleInventarioFisico: [],
        estado_inventario_codigo: mov.estado_inventario_codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    // this.loading = true
    this.inventarioFisicoService.eliminarInventarioFisico(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        // this.loading = false
        return;
      }

      this.toastrService.success('Operación exitosa');
      this.buscar(1);
    });
  }
}
